import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminSessionsResponse, AdminSessionsParams } from '@utils/types/admin';

export const ADMIN_SESSIONS_QUERY_KEY = 'adminSessions';

/**
 * Hook to fetch all sessions across organizations (operations view)
 *
 * GET /api/admin/on-prem/sessions
 *
 * Returns all sessions with status, organization, timestamps
 */
export const useGetAdminSessions = (params: AdminSessionsParams = {}) => {
  const { offset = 0, limit = 25, status, organization_id, search } = params;

  const fetchSessions = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append('offset', String(offset));
    queryParams.append('limit', String(limit));
    if (status) {
      queryParams.append('status', status);
    }
    if (organization_id) {
      queryParams.append('organization_id', String(organization_id));
    }
    if (search) {
      queryParams.append('search', search);
    }

    const url = `api/admin/on-prem/sessions?${queryParams.toString()}`;
    const response = await Axios.get<AdminSessionsResponse>(url);
    return response.data;
  };

  return useQuery<AdminSessionsResponse, AxiosError<BaseError>>(
    [ADMIN_SESSIONS_QUERY_KEY, offset, limit, status, organization_id, search],
    fetchSessions,
    {
      useErrorBoundary: false,
      keepPreviousData: true,
      refetchInterval: 30000
    }
  );
};
